<script setup>
  import { defineProps, ref, onMounted, useTemplateRef, watch } from 'vue'
import Button from './Button.vue';

  const props = defineProps({
    tool: String,
    form: Object,
    formDefaults: Object,
    formMutator: Function,
    allowNonDefaults: Boolean
  })

  const copyTextRef = useTemplateRef('copyTextRef');
  // const copyButtonRef = useTemplateRef('copyButtonRef');

  const hasMounted = ref(false);
  const pulsing = ref(false)

  onMounted(()=>{
    hasMounted.value = true;
    setTimeout(()=>{
      for(const [key, value] of new URLSearchParams(window.location.hash.slice(1))) {
        if (props.allowNonDefaults || props.formDefaults[key] != undefined){
          props.formMutator(key, value);
        }
      }
    }, 500);
  });


  const copyFormLink = ()=>{
    navigator.clipboard.writeText(window.location.href);
    copyTextRef.value.innerText = "Copied!"
    setTimeout(()=>{
      copyTextRef.value.innerText = "Copy Form Link"
    }, 1000);
  };

  let debounceTimer = 0;
  watch(props.form, ()=>{
    if (hasMounted.value){

      let params = {};
      for(var k in props.form){
        if (!props.allowNonDefaults && props.formDefaults[k] === undefined){
          continue;
        }
        if (props.form[k] != props.formDefaults[k]){
          params[k] = props.form[k];
        }
      }
      window.location.hash = new URLSearchParams(params);

      // Pulse the button when there's an update
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(()=>{
        pulsing.value = true
        setTimeout(()=>{
          pulsing.value = false
        }, 2200);
      }, 200)
    }
  });

</script>
<template>
  <Button
    :tool="props.tool"
    :class="pulsing ? 'pulse-'+props.tool : ''"
    @click="copyFormLink"
  >
    <span ref="copyTextRef">Copy Form Link</span>
</Button>
</template>
